<template>
    <div id="hello">
        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
        </div>
        <div style="background: #8c5ba6; color: #fff; text-align: center; padding: 10px; font-size: 1.1em; font-weight: 600;">
            <p>Rozpoczęcie budowy: 2024 r.<br>
Zakończenie budowy: 2026 r.</p>
        </div>

        <div id="content" class="homepage" >


            <h1 class="text-center" style="padding-top: 40px;"><img src="@/assets/img/LOGO.svg?ver=1" alt="Kaczeńcova" style="width: 200px;"></h1>


            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns" style="flex-direction: row-reverse;">

                        <div class="column is-three-fifths">
                            <h2>Dlaczego własnie „Kaczeńcova”?</h2>
                            <p>Ponieważ zależy nam na tym, aby podkreślić, że inwestycja znajdzie się w bliskim sąsiedztwie natury. Ulica Kaczeńcowa wychodzi na pobliski wąwóz, sama nazwa kojarzy się ponadto z gatunkiem rośliny z rodziny zielnej należącej do rodziny jaskrowatych. Kaczeńce, bo właśnie o nie chodzi, bardzo łatwo rozpoznać spośród innych kwiatów łąkowych. Posiadają niewielkie, ale charakterystyczne kwiaty w żółtym kolorze. Podobnie jest z naszą inwestycją. „Kaczeńcova” to kameralna inwestycja, która z pewnością zapadnie w pamięć wielu naszym klientom.
                            </p>
<p>Dlaczego jednak „Kaczeńcova” przez „V”? Zdecydowaliśmy się na zastąpienie litery „W”, gdyż wierzymy, że fundamenty naszej inwestycji będą tak samo solidne, jak solidny staje się z czasem pień drzewa, z którego zaczyna wyrastać wiele splątanych gałęzi. „V” jest dla nas symbolem przejrzystości i wizualnej lekkości. Chcemy, aby nasi klienci nie mieli żadnych wątpliwości: mieszkania w tej inwestycji czekają właśnie na nich.</p>
                        </div>

                        <div class="column is-two-fifths">
                            <a @click="index = 0"><img :src="photos[0]" v-animate-onscroll="'animated'" class="fadeInDown"></a>
                        </div>
                    </div>

                </div>
            </section>

            <hr>



            <section class="section" style="padding-top: 80px; padding-bottom: 80px;">
                <div class="container f-icons is-fluid">
                    <div class="columns ">
                         <div class="column">

                            <h2 class="main-title" style="text-align: center;">Kaczeńcova to...</h2>
                            

                        </div>
                        </div>
                        <div class="columns top">
                            <div class="column is-one-third is-offset-one-third text-center">
                            <div class="f-icon"><img src="@/assets/img/chair.svg?ver=1"></div>
                            <h3>Przestrzeń do wypoczynku</h3>
                            <p>
Mieszkania z pięknymi ogródkami, dużymi balkonami i/lub tarasami</p>
                            </div>
                            </div>
                            <div class="columns top">

                         <div class="column text-center">
                            <div class="f-icon"><img src="@/assets/img/001-location.svg?ver=1"></div>
                            <h3>Świetna lokalizacja</h3>
                            <p>
W zagospodarowanej, zielonej części Lublina w dzielnicy Czuby</p>
                            </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/006-measure.svg?ver=1"></div>
                                <h3>Zróżnicowany metraż</h3>
                            <p>
                                Dostępność mieszkań o powie&shy;rzchni zaczynającej się od 25,94m<sup>2</sup> i kończącej się aż na 112,80 m<sup>2</sup></p>
                            </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/005-park.svg?ver=1"></div>
                                <h3>Obecność zieleni</h3>
                            <p>Mnogość klombów, trawników i nasadzeń.<br>
                                Rozległy, zielony wąwóz w sąsiedztwie inwestycji.</p>
                            </div>
                    </div>
                    <div class="columns top">
                         <div class="column text-center">
                            <div class="f-icon"><img src="@/assets/img/004-parking-area.svg?ver=1"></div>
                            <h3>Miejsca do parkowania</h3><p>...oraz komórki lokatorskie dla wszystkich naszych klientów</p> 
                            
                            </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/family.svg?ver=1"></div>
                                <h3>Idealne dla rodzin</h3>
                                <p>Mieszkania dostosowane do potrzeb rodzin z dziećmi</p>
                          
                            </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/003-rooftop.svg?ver=1"></div>
                                <h3>Tarasy na dachu</h3>
                                <p>Tarasy przynależne do wybranych mieszkań.</p>
                       
                            </div>

                            
                    </div>
                    <div class="columns">
                        <div class="column is-one-third is-offset-one-third text-center">
                            <div class="f-icon"><img src="@/assets/img/chair.svg?ver=1"></div>
                            <h3>Wiele udogodnień</h3>
                            <p>
                                Stojaki rowerowe, plac zabaw, czujniki gazu, system przeciwpożarowy, domofony i in. </p>
                            </div>
                    </div>

                </div>
            </section>

            <hr>

<section class="section">
    <div class="container  is-fluid">
        <div class="columns">
            <div class="column is-full" style="text-align: center;">
                <h2>LOKALIZACJA</h2>
                <br>
                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2498.299678880955!2d22.499952876301858!3d51.23197553078707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTHCsDEzJzU1LjEiTiAyMsKwMzAnMDkuMSJF!5e0!3m2!1spl!2spl!4v1693394007866!5m2!1spl!2spl" height="400" frameborder="0" style="border:0; width: 100%; filter: grayscale(100)" allowfullscreen="" aria-hidden="false" tabindex="0" ></iframe> 
                <p style="text-align: center;"><br><a href="/lokalizacja">Zobacz więcej</a></p>
              </div>
                
               
            </div>

    </div>
</section>


            <hr>

            <section class="section">
        <div class="container is-fluid" id="contact">
            <div class="columns ">
                         <div class="column">

                            <h2 class="main-title" style="text-align: center;">BIURO SPRZEDAŻY</h2>
                            </div>
                            </div>
            <div class="columns top">

                <div class="column is-one-twos"  style="text-align: center;">
                    
                        <h3 style="margin-top: 0;">Helvetia City sp. z o.o.</h3>
                        <p>
                        ul. Jutrzenki 3 lokal nr 70<br> 20-538 Lublin<br> (II piętro, klatka III).
                        <br>
                    </p>
                </div>

                <div class="column is-one-twos " style="text-align: center;">
                    <p><span style="white-space: nowrap;">Poniedziałek – Piątek,</span> <span style="white-space: nowrap;">8:00 – 16:00</span></p>
                    <p><a href="mailto:sprzedaz@kaczencova.pl"><font-awesome-icon icon="envelope" /> sprzedaz@kaczencova.pl</a></p>
                    <p><a href="tel:817108027"><font-awesome-icon icon="phone" /> 81 710 80 27</a>
                        <br><a href="tel:789151482"><font-awesome-icon icon="phone" /> 789 151 482 </a></p>
                    <br>
                </div>
            </div>
            

        </div>
        </section>





        </div>







        <CoolLightBox
                :items="photos"
                :index="index"
                @close="index = null">
        </CoolLightBox>


    </div>
</template>

<script>
    import Render from "../components/Render";
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isDay: false,
                photos: [require('@/assets/img/1_Post.jpg'),
                        require('@/assets/img/2_Post.jpg'),
],
                    index: null
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            }
        },

        components: {
            Render: Render, CoolLightBox
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
